import { Injectable } from '@angular/core';
import { NgbDate, NgbDatepicker, NgbDatepickerKeyboardService } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';

const Key = {
  End: 'End',
  Home: 'Home',
  Tab: 'Tab'
};
enum WeekMoment {
  Start,
  End
}

@Injectable()
export class CustomKeyboardService extends NgbDatepickerKeyboardService {
  processKey(event: KeyboardEvent, dp: NgbDatepicker): void {
    const state = dp.state;
    switch (event.code) {
      case Key.End:
        dp.focusDate(this.getWeekMoment(state.focusedDate, WeekMoment.End));
        break;
      case Key.Home:
        dp.focusDate(this.getWeekMoment(state.focusedDate, WeekMoment.Start));
        break;
      default:
        super.processKey(event, dp);
        return;
    }
    event.preventDefault();
    event.stopPropagation();
  }

  private getWeekMoment(date: NgbDate, weekMoment: number): NgbDate {
    const focusedDate = moment(`${date.year}-${date.month.toString().padStart(2, '0')}-${date.day.toString().padStart(2, '0')}`)
    const endOfWeek = weekMoment === WeekMoment.Start ? focusedDate.startOf('isoWeek') : focusedDate.endOf('isoWeek');
    return new NgbDate(endOfWeek.year(), endOfWeek.month() + 1, endOfWeek.date())
  }
}
